module.exports = __webpack_public_path__ + "static/media/citizenship.73d83316.svg";